import { DataSeriesUnit } from "src/components/monitoring/commonTypes";

/**
 * Defines each line series to be plotted in the line chart
 */
export type LineChartItem = {
    /** Unique identifier for each line series - MUST be chart legend type
     */
    id: string;
    /** Label of chart legend type. */
    label: string;
    /** Data points for the line series */
    data: ChartItemData[];
    /** The unit for data values */
    unit: DataSeriesUnit;
    /** Level of the line series on the chart to establish an order between lines. */
    level: LineChartLevel;
    /** The color and optional gradient color of the line chart. Should be a valid CSS color value. */
    color: string;
    /** Optional gradient effect for the line color */
    gradient?: "NORMAL" | "SOFT";
    /** Whether to plot the line linearly, default is false */
    linear?: boolean;
    /** Whether to hide the line, default is false. Can be combined with gradient. */
    hideLine?: boolean;
};

export type ChartItemData = {
    x: Date | number;
    y: number;
    fill?: string;
    hasArea?: boolean;
};

export enum LineChartLevel {
    FRONT = "front",
    MIDDLE = "middle",
    BACK = "back",
}

export type SelectedTimeValues = {
    selectedTime: string;
    values: Record<string, number>[];
};
